import type { Span } from '../../api/tracesService';

export interface SpanNode {
  span: Span;
  depth: number;
}

export function buildSpanTree(spans: Span[]): SpanNode[] {
  const byId = new Map(spans.map((s) => [s.span_id, s]));
  const children = new Map<string, Span[]>();
  const roots: Span[] = [];

  for (const s of spans) {
    if (!s.parent_span_id || !byId.has(s.parent_span_id)) {
      roots.push(s);
    } else {
      const list = children.get(s.parent_span_id) ?? [];
      list.push(s);
      children.set(s.parent_span_id, list);
    }
  }

  const out: SpanNode[] = [];
  const visit = (span: Span, depth: number): void => {
    out.push({ span, depth });
    const kids = (children.get(span.span_id) ?? [])
      .slice()
      .sort((a, b) => a.timestamp.localeCompare(b.timestamp));
    for (const kid of kids) visit(kid, depth + 1);
  };

  roots
    .slice()
    .sort((a, b) => a.timestamp.localeCompare(b.timestamp))
    .forEach((r) => visit(r, 0));

  return out;
}
